<template>

    <body>
        <div class="view">
            <!-- <div class="decorate">
                <div class="cricle1"></div>
                <div class="cricle2"></div>
                <div class="cricle3"></div>
                <div class="cricle4"></div>
            </div> -->
            <router-view></router-view>
        </div>
    </body>
</template>
<script>
    import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
    export default {
        components: {
        },
        data: function () {
            return {
                scrollY: 0,
                dialogShow: true,
                backPath: '/',
                pageName: '金币商城',
            };
        },
        computed: {
            ...mapState("homePage", ["Syssetting"]),
        },
        methods: {
            ...mapActions([
                'fetchSyssetting'
            ]),
            ...mapMutations("homePage", ["setSyssetting"]),
        },
        created() {
            // this.sensors.login(`${this.$route.query.apptype}_${this.$route.query.uid}`)
            // this.$store.dispatch('globle/fetchGloble');
        },
        mounted() {
        }
    };
</script>